export default __webpack_public_path__ + "static/media/480_dummy2016-ferienwohnung01-de.df8c4819.png";